





























import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import SidebarItem from './SidebarItem.vue'
import SidebarLogo from './SidebarLogo.vue'
import AsideMenu from './AsideMenu.vue'
import variables from '@/styles/_variables.scss'
import { RouteConfig } from 'vue-router'
import { omit } from '../../../utils/tool'

@Component({
  name: 'SideBar',
  components: {
    SidebarItem,
    SidebarLogo,
    AsideMenu
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }

  get routes() {
    let secondRoutes: RouteConfig[] = (this.$router as any).options.routes
    // 生成只有二级的路由表
    let tempRoutes: RouteConfig[] = JSON.parse(JSON.stringify(secondRoutes))
    tempRoutes.forEach(item => {
      if (item.children) {
        item.children.forEach(item1 => {
          if (item1.children) {
            omit(item1 as any, ['children'])
          }
        })
      }
    })
    return tempRoutes
  }

  get variables() {
    return variables
  }
  // 高亮侧栏
  get activeMenu() {
    const route = this.$route
    const { meta, path } = route
    let activePathList = path.split('/')
    let activePath: string = ''
    if (activePathList.length > 2) {
      activePath = `/${activePathList[1]}/${activePathList[2]}`
    } else {
      activePath = `/${activePathList[1]}`
    }
    return activePath
  }

  get isCollapse() {
    return !this.sidebar.opened
  }
}
